
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response } from "@angular/http";
import { TokenInterceptor } from "app/authorized-http.service";
import { UtilsService } from "app/services/utils.service";
import { AdminProfileResource } from "app/models/AdminProfileResource";
import { UserResource } from 'app/models/UserResource';
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";


@Injectable()
export class SidebarService {

	constructor(private http: HttpClient, private httpa: TokenInterceptor, private utilsService: UtilsService) { }

	/* getAdminProfile(): Observable<AdminProfileResource> {
		return this.http.get<AdminProfileResource> (environment['url'] +'/admin/profile/get')
	} */

	private AdminProfileResource(res: Response) {
		let body = res.json()
		return body || [] // returneaza vector gol
	}



	getUserProfile(url): Observable<UserResource> {
		return this.http.get<UserResource>(environment['url'] +url)
	}

}
